// eslint:disable:no-default-export no-unused-expression
import { CaseReceipt } from '../area/case';
import { CaseCreator } from '../area/case/create';
import { Startup } from '../area/startup-anonymous/startup';

import * as React from 'react';
import { Route } from 'react-router-dom';

import { routeConstants } from './route-constants';
import { AppSetting } from 'dependencies/appsettings';
import { AnonymousLayout } from 'app/shell/anonymous/anonymous-layout';
import { CodeSelector } from 'app/area/code-selector/code-selector';
import { Editor } from 'app/area/case/edit';
import { withCasePassword } from 'app/area/case/case-password';
import { withRecaptchaApi } from 'app/area/case/recaptcha';
import { withRouter } from 'app/components/enhancers/with-router';
import { generateRouteLevels } from 'app/routes/route-helpers';
import { AuthProvider } from 'app/shell/auth-provider';
import { authProvider } from 'app/startup/anonymous/auth';
import { DraftReceipt } from 'app/area/case/draft/draft-receipt';
const StartupWithRouter = withRouter(Startup);
const CaseWithRouter = withRouter(CaseReceipt);
const DraftWithRouter = withRouter(withCasePassword(DraftReceipt));
const CaseCreatorComponent = withRouter(withRecaptchaApi(CaseCreator));
const EditorWithRouter = withRouter(withCasePassword(withRecaptchaApi(Editor)));
const CodeSelectorWithRouter = withRouter(CodeSelector);

/**
 * Routes for the anonymous web app
 */

const texts = (AppSetting.Translations as any).app; //TODO:
const NotFound: any = () => (<div>{texts && texts.logoutNotFoundError}</div>);// eslint:disable-line

// eslint-disable-next-line import/no-default-export
export default (<Route element={<AuthProvider authProvider={authProvider}><AnonymousLayout /></AuthProvider>}>
  <Route path={routeConstants.startupView} element={< StartupWithRouter />} />
  {generateRouteLevels({ component: CaseWithRouter, prefix: routeConstants.caseView })}
  {generateRouteLevels({ component: DraftWithRouter, prefix: routeConstants.draftView })}
  <Route path={routeConstants.createDraft} element={<CaseCreatorComponent />} />
  <Route path={routeConstants.caseEdit} element={<EditorWithRouter />} />
  <Route path={routeConstants.select} element={<CodeSelectorWithRouter />} />
  <Route path="*" element={NotFound} />
</Route>);

// Allow hot reloading of routes
if (module.hot) {
  module.hot.accept();
}
